
export function redirect() {
    const fixedHeader = document.querySelector('.header');

    const body = document.body;
    const initialScrollTarget = body.dataset.scrollTarget;
    
    if(initialScrollTarget){
        const targetElement = document.querySelector(`#${initialScrollTarget}`);

        if(targetElement){

            let wasFixed = fixedHeader.classList.contains('fixed');
            if(!wasFixed){
                fixedHeader.classList.add('fixed');
            }
                        
            setTimeout(() => {
                const headerHeight = fixedHeader.offsetHeight;
                const computedStyle = window.getComputedStyle(targetElement);
                const targetMarginTop = parseFloat(computedStyle.marginTop) || 0;

                const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = targetPosition - headerHeight - targetMarginTop;
                
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
                
                setTimeout(() => {
                    body.classList.add('fade-in');
                }, 100);
                setTimeout(() => {
                    body.removeAttribute('data-scroll-target');
                }, 1000);
            }, 100);
            
        }else{
            body.classList.add('fade-in')
        }
    }else{
        body.classList.add('fade-in')
    }
}

export function actualizarURL() {

    const sections = document.querySelectorAll('section[id]');
    const observerOptions = {
        root: null, //observer con respecto al viewport
        rootMargin: '0px',
        threshold: 0.5
    };
    const observer = new IntersectionObserver(entries =>{
        entries.forEach(entry =>{
            const scrollTarget =  document.body.dataset.scrollTarget;
            if(entry.isIntersecting){
                
                if(!scrollTarget){
                    if(entry.target.dataset.isUrl === 'true'){
                        //si es visible actualiza URL
                        const sectionID = entry.target.id;
                        const newURL = `/${sectionID}`;
                        history.replaceState(null, '', newURL);
                    }
                }
            }
        });
    }, observerOptions);

    sections.forEach(section =>{
        observer.observe(section);
    })

    const initalSection = window.location.hash.substring(1);
    if(initalSection){
        const targetSection = document.getElementById(initalSection);
        if(targetSection){
            setTimeout(() => {
                targetSection.scrollIntoView({behavior: 'smooth'});
            }, 100);
        }
    }    
}